<template>
  <div>
    <ExtraKmCategoryFactorsForm />
    <Divider />
    <PricesPerExtraKmForm />
    <Divider />
    <InclusiveKmForm />
    <Divider />
    <div class="flex justify-end">
      <CVButton variant="default" @click="handleSave">{{ t('save') }}</CVButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { UpdateYieldManagementSettingsDto } from '@carvia/ros-client-types';
import { useI18n } from 'vue-i18n';
import Divider from '@/components/Divider.vue';
import { useForm } from 'vee-validate';
import ExtraKmCategoryFactorsForm from '@/views/yield-management/yield-management-settings/ExtraKmCategoryFactorsForm.vue';
import PricesPerExtraKmForm from '@/views/yield-management/yield-management-settings/PricesPerExtraKmForm.vue';
import InclusiveKmForm from '@/views/yield-management/yield-management-settings/InclusiveKmForm.vue';
import { cloneDeep } from 'lodash';
import { usePreventLeavingUnsavedForm } from '@/hooks/use-prevent-leaving-unsaved-form.ts';
import { formHasChanged } from '@/hooks/use-form-has-changed.ts';
import { yieldManagementKmSchema } from '@/validation/yield-management-km.schema.ts';

const props = defineProps<{
  settingsDto: UpdateYieldManagementSettingsDto;
}>();

const emit = defineEmits<{
  (e: 'save', value: UpdateYieldManagementSettingsDto): void;
}>();

const { t } = useI18n();

let initialValues = cloneDeep(props.settingsDto);

const { values: formValues, handleSubmit } = useForm({
  initialValues,
  validationSchema: yieldManagementKmSchema,
});

const handleSave = handleSubmit(
  (values) => {
    emit('save', values);
    initialValues = cloneDeep(formValues);
  },
  ({ errors }) => {
    console.error('Validation errors:', errors);
  },
);

usePreventLeavingUnsavedForm(() => formHasChanged(initialValues, formValues));
</script>

<i18n lang="json">
{
  "en": {
    "deposits": "Deposits"
  },
  "de": {
    "deposits": "Kautionen"
  },
  "es": {
    "deposits": "Depósitos"
  }
}
</i18n>
